export const router = {
  HOME: '/',
  WHEEL: '/wheel'
};
